<template>
  <div>
    <b-container fluid>
      <b-row>
        <ul class="histories">
          <li
            class="histories--history"
            :class="{ 'histories--history__active': isShowTodaysHistory }"
            @click="showTodaysHistory()"
          >
            {{ $t('orderHistory.todaysOrderHistory') }}
          </li>
          <li
            class="histories--history"
            :class="{ 'histories--history__active': isShowPastHistory }"
            @click="showPastHistory()"
          >
            {{ $t('orderHistory.pastOrderHistory') }}
          </li>
        </ul>
      </b-row>
    </b-container>
    <todays-order-history v-if="isShowTodaysHistory" />
    <past-order-history v-if="isShowPastHistory" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PastOrderHistory from '@/components/orderHistory/PastOrderHistory'
import TodaysOrderHistory from '@/components/orderHistory/TodaysOrderHistory'
export default {
  components: {
    PastOrderHistory,
    TodaysOrderHistory,
  },
  data() {
    return {
      isShowTodaysHistory: true, // 今日の注文履歴の表示
      isShowPastHistory: false, // 過去の注文履歴の表示
    }
  },
  computed: {
    ...mapGetters({
      language: 'setting/getLanguage',
    }),
  },
  watch: {
    language() {
      this.$emit('updateHead')
    },
  },
  methods: {
    showTodaysHistory() {
      this.isShowTodaysHistory = true
      this.isShowPastHistory = false
    },
    showPastHistory() {
      this.isShowTodaysHistory = false
      this.isShowPastHistory = true
    },
  },
  head: {
    title() {
      return {
        inner: this.$t(`pageTitle.${this.$route.name}`),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.histories {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 65px;
  line-height: 65px;
  border-bottom: solid 2px #e5e4e2;
  &--history {
    color: #898989;
    width: 50%;
    text-align: center;
    font-size: 0.9rem;
    font-weight: bold;
    &__active {
      position: relative;
      color: #d22523;
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0-2px;
        left: 0;
        background-color: #d22523;
      }
    }
  }
}
</style>
